/* eslint-disable react/no-danger */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, Header, Button, Segment, Dropdown } from 'semantic-ui-react';

class SelectBox extends PureComponent {
  static propTypes = {
    header: PropTypes.string,
    content: PropTypes.string,
    buttonText: PropTypes.string,
    placeholder: PropTypes.string,
    action: PropTypes.func,
    options: PropTypes.array,
    propagateClosure: PropTypes.func,
    type: PropTypes.string,
    open: PropTypes.bool,
  }

  static defaultProps = {
    header: 'Demande de confirmation',
    content: '',
    buttonText: 'Confirmer',
    placeholder: 'Sélectionnez une valeur',
    action: () => null,
    options: [],
    propagateClosure: () => null,
    type: null,
    open: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      selected: null,
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleEscape, false);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.state.open) {
      this.setState({ open: true });
    }
    if (nextProps.options.length === 1) {
      this.setState({ selected: nextProps.options[0].value });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscape, false);
  }

  handleEscape = (e) => {
    if (e.keyCode === 27 && this.state.open) {
      this.handleClose();
    }
  }

  handleClose = () => {
    this.props.propagateClosure();
    this.setState({ open: false, selected: null });
  }

  render() {
    let icon;
    let negativity = false;
    switch (this.props.type) {
      case 'destructive':
        icon = 'red remove circle';
        negativity = true;
        break;
      case 'neutral':
        icon = 'blue help circle';
        break;
      case 'create':
        icon = 'green add square';
        break;
      case 'warn':
        icon = 'yellow warning sign';
        break;
      default:
        icon = 'blue info circle';
    }
    // console.log(this.props.options.length)
    return (
      <Modal
        open={this.state.open}
        size="tiny"
      >
        <Header icon={{ className: icon }} content={this.props.header} />
        <Modal.Content>
          <Segment basic textAlign="center">
            <p dangerouslySetInnerHTML={{ __html: this.props.content }} />
            <Dropdown
              placeholder={this.props.placeholder}
              fluid
              search
              selection
              defaultValue={this.props.options.length === 1 ? this.props.options[0].value : null}
              options={this.props.options}
              onChange={(e, { value }) => {
                // console.log(value);
                this.setState({ selected: value });
              }}
            />
          </Segment>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.handleClose}>
            Annuler
          </Button>
          <Button
            autoFocus
            color="blue"
            primary
            negative={negativity}
            disabled={this.state.selected === null}
            onClick={() => {
              this.handleClose();
              this.props.action(this.state.selected);
            }}
          >
            {this.props.buttonText}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default SelectBox;



// WEBPACK FOOTER //
// ./src/components/Modals/SelectBox.js